import moment from "moment";
import React from "react";

function CancelShowModal({ cancelProps }) {
  const { cancelIsOpen, setCancelIsOpen,cancelTrip,refundStatus } = cancelProps;

  const modalStyles = {
    display: cancelIsOpen ? "flex" : "none",
    alignItems: "center",
    justifyContent: "center",
    position: "fixed",
    zIndex: 1050,
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.6)",
    padding: "20px",
  };

  const modalContentStyles = {
    backgroundColor: "#fff",
    width: "100%",
    maxWidth: "500px",
    borderRadius: "12px",
    padding: "30px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
    textAlign: "center",
  };

  const headerStyles = {
    marginBottom: "20px",
  };

  const buttonContainer = {
    display: "flex",
    justifyContent: "center",
    marginTop: "30px",
    
  };

  const buttonStyle = {
    padding: "12px 24px",
    borderRadius: "30px",
    fontSize: "16px",
    cursor: "pointer",
    border: "none",
    transition: "background-color 0.3s ease",
  };

  const cancelButtonStyle = {
    ...buttonStyle,
    backgroundColor: "#6c757d",
    color: "#fff",
    marginRight : "20px"
  };

  const confirmButtonStyle = {
    ...buttonStyle,
    backgroundColor: "#ff8901",
    color: "#fff",
    marginLeft :"20px"
  };
  const td = {
    width : "100px"
  }

  // Updated style for the row with location details, using flexbox.
  const locationRowStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#f1f1f1",
    padding: "15px",
    borderRadius: "8px",
    margin: "15px 0",
  };

  const locationItemStyle = {
    margin: "0 10px",
    flex: 1,
    textAlign: "center",
  };
  // console.log(JSON.parse(data.extra_stops));
  console.log(refundStatus);

  return (
    <div style={modalStyles}>
      <div style={modalContentStyles}>
        <div style={headerStyles}>
          <h2 style={{ color: "#cb2734", marginBottom: "10px" }}>
            Vimo Services
          </h2>
          {refundStatus.status == true ?
          (<h5 style={{ fontWeight: "bold" }}>Wallet Refund Available!. <br/> Are you sure want to cancel the Trip ?</h5>):
          <h5 style={{ fontWeight: "bold" }}>Due to the Trip is less than {refundStatus?.cancelation_hour} {refundStatus?.cancelation_hour == 1 ? "hour": "hours" } from now,No Refund is available.Do you want cancel the trip?</h5>
           }
          
        </div>
        <div style={buttonContainer}>
          <button
            type="button"
            className="not_disble_fields"
            style={cancelButtonStyle}
            onClick={() => setCancelIsOpen(false)}
          >
            Close
          </button>
          <button
            className="not_disble_fields"
            type="button"
            style={confirmButtonStyle}
            onClick={cancelTrip}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}

export default CancelShowModal;
